import { queryKeyFn } from '@sit/client-shared';
import { useNotificationSocket } from '@sit/notifications-client';
import { NotificationPayload } from '@sit/notifications-shared';
import { useQueryClient } from '@tanstack/react-query';
import { useEffect, useState } from 'react';

export function useLatestServerNotification() {
  const [lastNotification, setLastNotification] = useState<NotificationPayload | null>(null);
  const queryClient = useQueryClient();
  const notificationSocket = useNotificationSocket();

  useEffect(() => {
    const cleanupNotif = notificationSocket.onNotification((notification) => {
      setLastNotification(notification);
    });

    // Invalidate on reconnect to ensure no missed messages
    const cleanupReconnect = notificationSocket.onReconnect(() => {
      queryClient.invalidateQueries({
        queryKey: queryKeyFn({
          path: '/notifications',
          operationId: 'getApiNotifications',
          variables: {},
        }),
      });
    });

    return () => {
      cleanupNotif();
      cleanupReconnect();
    };
  }, [queryClient, notificationSocket]);

  return {
    data: lastNotification ? { newNotification: lastNotification } : undefined,
    loading: false,
    error: undefined,
  };
}
